import { Box, Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EditNoteIcon from "@mui/icons-material/EditNote";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { format } from "date-fns";
import { driverLeaveApis } from "../../../Data/axios";

const ViewMoreLeaveAppreciation = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const openDropMenu = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const location = useLocation();
  const rowData = location.state;
  const {
    id,

    driver_id,
    owner_id,
    start_date,
    end_date,
    type,
    reason,
    status,
    approved_by,
    approved_at,
    file,
    note,
  } = rowData || {};
  // const date = new Date(created_at);
  // const day = String(date.getDate()).padStart(2, "0"); // Adds leading zero if necessary
  // const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
  // const year = date.getFullYear();
  // const formattedDate = `${day}-${month}-${year}`;

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const formattedLeaveDate = (date) => format(new Date(date), "dd-MM-yyyy");
  // async function handleDelete() {
  //   const response = await fetch(
  //     `https://rptpl.roadpilot.co.in/public/api/DeleteKnowledagebase/${id}`,
  //     {
  //       method: "DELETE",
  //     }
  //   );
  //   const result = await response.json(); // Assigning to a new variable
  //   navigate("/notice");
  // }

  const convertToPlainText = (htmlContent) => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return parsedHtml.body.textContent || "";
  };
  const convertToUserType = (value) => {
    if (value === "1") return "Client";
    if (value === "2") return "Employee";
    if (value === "3") return "App User";
    return "Unknown"; // Fallback for invalid values
  };
  const approvedType = (value) => {
    if (value === "0") return "Rejected";
    if (value === "2") return "Approved";

    return "Unknown"; // Fallback for invalid values
  };

  return (
    <Box
      sx={{
        color: "#333",
        padding: "20px",
        fontSize: "20px",
        fontWeight: 550,
      }}
    >
      <Box
        sx={{
          color: "#333",
          bgcolor: "#fff",
          height: "auto",
          paddingBelow: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgb(187, 186, 186) ",
          }}
        >
          <Box sx={{ padding: "20px" }}>Appreciation Details</Box>
        </Box>
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Award
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {""}
                <br />
                {driver_id || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Award Date
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {""}
                <br />
                {owner_id || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Summary
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                -----
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Given To
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {"date" || ""}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewMoreLeaveAppreciation;
